// Studyo Today Backend
// Package studyo.today.subscriptions.v1.resources
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/subscriptions/v1/resources/entitlement_value_kind.proto (package studyo.today.subscriptions.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/subscriptions/v1/resources/entitlement_value_kind.proto.
 */
export const file_studyo_today_subscriptions_v1_resources_entitlement_value_kind = /*@__PURE__*/
  fileDesc("CkRzdHVkeW8vdG9kYXkvc3Vic2NyaXB0aW9ucy92MS9yZXNvdXJjZXMvZW50aXRsZW1lbnRfdmFsdWVfa2luZC5wcm90bxInc3R1ZHlvLnRvZGF5LnN1YnNjcmlwdGlvbnMudjEucmVzb3VyY2VzKqEBChRFbnRpdGxlbWVudFZhbHVlS2luZBImCiJFTlRJVExFTUVOVF9WQUxVRV9LSU5EX1VOU1BFQ0lGSUVEEAASMgouRU5USVRMRU1FTlRfVkFMVUVfS0lORF9NQVhfU1RVREVOVFNfUEVSX1NDSE9PTBABEi0KKUVOVElUTEVNRU5UX1ZBTFVFX0tJTkRfTUFYX0FDVElWRV9TQ0hPT0xTEAJCL6oCLFN0dWR5by5Ub2RheS5TdWJzY3JpcHRpb25zLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM");

/**
 * Describes the enum studyo.today.subscriptions.v1.resources.EntitlementValueKind.
 */
export const EntitlementValueKindSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_subscriptions_v1_resources_entitlement_value_kind, 0);

/**
 * The kind of a value tied to an entitlement.
 *
 * @generated from enum studyo.today.subscriptions.v1.resources.EntitlementValueKind
 */
export const EntitlementValueKind = /*@__PURE__*/
  tsEnum(EntitlementValueKindSchema);

